import { render, staticRenderFns } from "./SkodePrejsnje.vue?vue&type=template&id=2b9e20c4&scoped=true&"
import script from "./SkodePrejsnje.vue?vue&type=script&lang=js&"
export * from "./SkodePrejsnje.vue?vue&type=script&lang=js&"
import style0 from "./SkodePrejsnje.vue?vue&type=style&index=0&id=2b9e20c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e20c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
